<!--
	Prihlasovacia obrazovka
-->
<script lang="ts">
	import type { Writable } from "svelte/store";
	import type { DialerAgentConfiguration } from "../libs/app/configuration";

	import { api, dialerAgent } from "../bootstrap";
	import { useNavigate, useLocation } from "svelte-navigator";

	const navigate = useNavigate();
	const location = useLocation();

	let username = "";
	let password = "";

	$: disabledSend = checkDisabledSend(username, password);

	const configuration: Writable<DialerAgentConfiguration> = dialerAgent.configuration;
	configuration.set(null);

	function checkDisabledSend(username, password) {
		if (!username || !password) {
			return true;
		}

		return false;
	}

	/**
	 * Overenie prihlasovacích údajov
	 */
	async function login() {
		const conf = await api.login(username, password);

		if (conf === false) {
			return;
		}

		configuration.set(conf);
		api.unpause();

		// uloženie záznamu o prihlásení do denníka sa urobí na serveri, nie je treba volať saveTimeTrackerEvent

		let from = ($location.state && $location.state.from) || "/main/summary";
		if (from === "/") {
			from = "/main/summary";
		}
		navigate(from, { replace: true });
	}
</script>

<svelte:head>
	<title>Prihlásenie | UniPBX Agent</title>
</svelte:head>

<h1>UniPBX Agent</h1>

<div class="form-signin">
	<form on:submit|preventDefault={login}>
		<h2 class="h3 mb-3 fw-normal text-center">Prihlásenie</h2>

		<div class="form-floating">
			<input type="text" class="form-control" id="floating-input" placeholder="Prihlasovacie meno" bind:value={username} required />
			<label for="floating-input">Prihlasovacie meno</label>
		</div>

		<div class="form-floating">
			<input type="password" class="form-control" id="floating-password" placeholder="Heslo" bind:value={password} required />
			<label for="floating-password">Heslo</label>
		</div>

		<button class="w-100 btn btn-lg btn-primary" type="submit" disabled={disabledSend}>Prihlásiť</button>
	</form>
</div>

<style lang="scss">
	h1 {
		text-align: center;
		margin-top: 4em;
	}

	.form-signin {
		width: 100%;
		max-width: 330px;
		padding: 15px;
		margin: 3em auto;
	}

	.form-signin .form-floating:focus-within {
		z-index: 2;
	}

	.form-signin input[type="text"] {
		margin-bottom: -1px;
		border-bottom-right-radius: 0;
		border-bottom-left-radius: 0;
	}

	.form-signin input[type="password"] {
		margin-bottom: 10px;
		border-top-left-radius: 0;
		border-top-right-radius: 0;
	}
</style>
